import { Image, Price, PageType } from '@spartacus/core';
import { BrandsEnum } from '@seb/web-design-system/core';

import { HowTo } from '../models/how-to.model';
import { InstructionsForUseList } from '../models/instructions-for-use.model';
import { Star } from '../models/star.model';
import { FreeEditorial } from '../models/free-editorial.model';
import { LiveChatAgentConfig } from '../models/live-chat-agent.model';
import { KlarnaContext } from '../models/klarna.model';
import { WhatIsInBox } from '../models/what-is-in-box.model';
import { CustomAddressForm } from '../models/custom-address.model';
import { RepairabilityIndex } from '../models/repairability-index.model';
import { FaqEntry } from '../models/faq.model';
import { ProductBenefit } from '../models/product-benefit.model';
import { Bundle } from '../models/bundle.model';
import { ExternalLogisticianEnum } from '../enums/external-logistician.enum';
import { RepairabilityEnum } from '../enums/repairability.enum';

declare module '@spartacus/core' {
  interface Product {
    accessories?: Product[];
    maxOrderQuantity?: number;
    accessoryCategorisation?: string;
    productsDesignedFor?: Product[];
    isAccessory?: boolean;
    onSale?: boolean;
    ecoTaxPrice?: Price;
    star?: Star;
    freeEditorialBU?: FreeEditorial;
    freeEditorialLocal?: FreeEditorial;
    standardImage?: Image[];
    externalLogistician?: ExternalLogisticianEnum;
    newProduct?: boolean;
    whatIsInBox?: WhatIsInBox;
    bestSeller?: boolean;
    claim?: string;
    commercialCode?: string;
    descriptionImages?: Image[];
    discountedPrice?: Price;
    recommendedPrice?: Price;
    faqs?: { faqEntries?: FaqEntry[] };
    formattedDiscountValue?: string;
    instructionsForUse?: InstructionsForUseList;
    isProductComparator?: boolean;
    promoMessageEnabled?: boolean;
    promoMessage?: string;
    topCategoryName?: string;
    subCategoryName?: string;
    sisCategory?: string;
    sisSubCategory?: string;
    shortDescription?: string;
    ssEditorialDescriptionDetail?: string;
    ssEditorialDescriptionTitle?: string;
    productBenefits?: ProductBenefit[];
    topBenefits?: ProductBenefit[];
    updateEditorial?: 'AUTOMATIC' | 'WYSIWYG';
    benefitHighLights?: string[];
    bundles?: Bundle[];
    indexedBundles?: Bundle[];
    howTo?: HowTo;
    keyClaimDisclaimer?: string;
    uspDisclaimer?: string;
    cmmfOtherDisclaimers?: string;
    reparabilityIncluded?: RepairabilityEnum;
    showChat?: boolean;
    liveChatAgentConfig?: LiveChatAgentConfig;
    productGenre?: string;
    shippingIncluded?: boolean;
    dividedData?: any;
    klarnaContext?: KlarnaContext;
    detachedPieces?: Product[];
    repairabilityIndex?: RepairabilityIndex;
    repairabilityStatus?: string;
    updateShortEditorial?: 'AUTOMATIC' | 'WYSIWYG';
    updateBenefitHighlights?: 'AUTOMATIC' | 'WYSIWYG';
    gsebAverageRating?: number;
    gsebNumberOfReviews?: number;
    brand?: BrandsEnum;
    superCategoryMarketingName?: string;
    reviewUrl?: string;
    displayExternalRatingAndReviewsWidget?: boolean;
    urlCsp?: string;
    urlIfu?: string;
    replacedBy?: Product;
    replacementProductURL?: string;
    strikethroughPrice?: boolean;
    indexFollow?: boolean;
    badges?: MadeIn[];
    orderInCategories?: string[];
    packDepth?: number;
    packHeight?: number;
    packWidth?: number;
    packVolume?: number;
    isBundle?: boolean;
    afterSalesServiceReferences?: string[];
    cmmf?: string;
    familyAnneeN?: string;
    family2?: string;
    descriptionTag?: string;
    primaryImages?: Image[];
    fallbackURL?: string;
    isMarketing?: boolean;
    agecLaw?: any;
  }

  interface VariantOption {
    product?: Product
  }

  interface VariantOptionQualifier {
    type?: string;
  }

  interface User {
    completedOrderCount?: number;
  }

  interface Address {
    addressName?: string;
    pickupID?: string;
    accountId?: string;
    contactFirstName?: string;
    contactLastName?: string;
    homePhone?: string;
    line3?: string;
    city?: string;
    countryCode?: string;
    street?: string;
    streetName?: string;
    streetNumber?: string;
    isMainAddress?: boolean;
    state?: string;
    contactCivility?: string;
    mobilePhone?: string;
    phone2?: string;
    phone?: string;
    postcode?: string;
    rcuAddressId?: string;
    errorCode?: string;
    details?: Record<string, any>[];
    addressGroup?: CustomAddressForm;
    billingAddress?: boolean;
  }

  interface Principal {
    encryptedEmail?: string;
  }

  interface Address {
    addressName?: string;
    pickupID?: string;
    accountId?: string;
    contactFirstName?: string;
    contactLastName?: string;
    homePhone?: string;
    line3?: string;
    city?: string;
    countryCode?: string;
    street?: string;
    streetName?: string;
    streetNumber?: string;
    isMainAddress?: boolean;
    state?: string;
    contactCivility?: string;
    mobilePhone?: string;
    phone2?: string;
    phone?: string;
    postcode?: string;
    rcuAddressId?: string;
    errorCode?: string;
    details?: Record<string, any>[];
    addressGroup?: CustomAddressForm;
    billingAddress?: boolean;
  }

  interface Principal {
    encryptedEmail?: string;
  }

  interface Address {
    addressName?: string;
    pickupID?: string;
    accountId?: string;
    contactFirstName?: string;
    contactLastName?: string;
    homePhone?: string;
    line3?: string;
    city?: string;
    countryCode?: string;
    street?: string;
    streetName?: string;
    streetNumber?: string;
    isMainAddress?: boolean;
    state?: string;
    contactCivility?: string;
    mobilePhone?: string;
    phone2?: string;
    phone?: string;
    postcode?: string;
    rcuAddressId?: string;
    errorCode?: string;
    details?: Record<string, any>[];
    addressGroup?: CustomAddressForm;
    billingAddress?: boolean;
  }

  interface Principal {
    encryptedEmail?: string;
  }

  interface Promotion {
    ruleGroup?: string;
  }

  interface Classification {
    type?: string;
  }

  interface MadeIn {
    badge?: string;
    media?: Image;
    siteBrand?: string;
    title?: string;
  }

  interface Stock {
    releaseDate?: string;
  }

  enum PageType {
    RECIPE_CATEGORY_PAGE = 'RecipeCategoryPage'
  }
}

// ATTENTION : Typescript normally doesn't allow to extend enum. This is a patch to add the new RECIPE_CATEGORY_PAGE value.
(PageType as any)['RECIPE_CATEGORY_PAGE'] = 'RecipeCategoryPage';
